import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

// https://stackoverflow.com/questions/69871987/react-router-v6-navigate-outside-of-components/70000286#70000286

const CustomRouter = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  // router is passed an external history object
  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default CustomRouter;
